module.exports = [
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "choose.json",
		"path": "/choose/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-11-update-collection.json",
		"path": "/aspnetcore-todo-api/11-update-collection/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "success.json",
		"path": "/success/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-10-update-singleton.json",
		"path": "/aspnetcore-todo-api/10-update-singleton/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-0-introduction.json",
		"path": "/aspnetcore-todo-api/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-1-getting-started.json",
		"path": "/aspnetcore-todo-api/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-2-modelling-representations.json",
		"path": "/aspnetcore-todo-api/2-modelling-representations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-3-modelling-domain-link-relations.json",
		"path": "/aspnetcore-todo-api/3-modelling-domain-link-relations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-4-constructing-representations.json",
		"path": "/aspnetcore-todo-api/4-constructing-representations/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-6-constructing-collection.json",
		"path": "/aspnetcore-todo-api/6-constructing-collection/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-8-constructing-search-resources.json",
		"path": "/aspnetcore-todo-api/8-constructing-search-resources/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-5-constructing-singleton.json",
		"path": "/aspnetcore-todo-api/5-constructing-singleton/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-9-create-resource.json",
		"path": "/aspnetcore-todo-api/9-create-resource/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "aspnetcore-todo-api-7-constructing-viritual.json",
		"path": "/aspnetcore-todo-api/7-constructing-viritual/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-0-introduction.json",
		"path": "/vue-todo-app/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-2-client-side-urls-and-routing.json",
		"path": "/vue-todo-app/2-client-side-urls-and-routing/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-1-getting-started.json",
		"path": "/vue-todo-app/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-3-application-cache.json",
		"path": "/vue-todo-app/3-application-cache/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-4-updates-and-deletes.json",
		"path": "/vue-todo-app/4-updates-and-deletes/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-5-on-demand-authentication.json",
		"path": "/vue-todo-app/5-on-demand-authentication/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-7-summary.json",
		"path": "/vue-todo-app/7-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-1-getting-started.json",
		"path": "/vue-api-browser/1-getting-started/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-todo-app-6-cloning-resources.json",
		"path": "/vue-todo-app/6-cloning-resources/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-2-build-html-representation.json",
		"path": "/vue-api-browser/2-build-html-representation/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-0-introduction.json",
		"path": "/vue-api-browser/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-3-build-html-content-negotiation.json",
		"path": "/vue-api-browser/3-build-html-content-negotiation/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-4-register-html-content-negotiation.json",
		"path": "/vue-api-browser/4-register-html-content-negotiation/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-5-request-json.json",
		"path": "/vue-api-browser/5-request-json/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-10-summary.json",
		"path": "/vue-api-browser/10-summary/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-6-displaying-with-interaction.json",
		"path": "/vue-api-browser/6-displaying-with-interaction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-8-displaying-form-values.json",
		"path": "/vue-api-browser/8-displaying-form-values/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-7-try-delete-representation.json",
		"path": "/vue-api-browser/7-try-delete-representation/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-0-introduction.json",
		"path": "/basics/0-introduction/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-1-minimally-layered-design.json",
		"path": "/basics/1-minimally-layered-design/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "vue-api-browser-9-submitting-forms.json",
		"path": "/vue-api-browser/9-submitting-forms/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-3-big-picture.json",
		"path": "/basics/3-big-picture/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-4-for-the-dedicated.json",
		"path": "/basics/4-for-the-dedicated/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "basics-2-navigating-api.json",
		"path": "/basics/2-navigating-api/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-0-multiple-clients.json",
		"path": "/advanced/0-multiple-clients/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-1-api-modelling.json",
		"path": "/advanced/1-api-modelling/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-2-forms-modelling.json",
		"path": "/advanced/2-forms-modelling/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-4-common-questions.json",
		"path": "/advanced/4-common-questions/"
	},
	{
		"componentChunkName": "page-component---src-templates-tutorials-tsx",
		"jsonName": "advanced-3-todo-domain.json",
		"path": "/advanced/3-todo-domain/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-tsx",
		"jsonName": "404.json",
		"path": "/404/"
	},
	{
		"componentChunkName": "page-component---src-pages-index-tsx",
		"jsonName": "index.json",
		"path": "/"
	},
	{
		"componentChunkName": "page-component---src-pages-404-tsx",
		"jsonName": "404-html.json",
		"path": "/404.html"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = ./.cache/pages.json
// module chunks = 50